import React, { useMemo } from 'react';
import { getS1, getS2 } from '../../../../common/utils';
import moment from 'moment';
import { Translate } from '../../WithTranslate';
import { TLCode } from '../../../../common/enums';

interface SemesterInfoProps {
  year: number | undefined;
  translate: Translate;
}

export const SemesterInfo = ({ year, translate }: SemesterInfoProps) => {
  const dateFormat = 'DD-MM-YYYY';
  const S1Dates = useMemo(() => {
    const s1 = getS1(year === undefined ? moment().year() : year);
    return (
      translate(TLCode.DutiesBetweenStart) +
      ' ' +
      moment(s1.beginning).format(dateFormat) +
      translate(TLCode.DutiesBetweenEnd) +
      moment(s1.end).format(dateFormat)
    );
  }, [year, translate]);

  const S2Dates = useMemo(() => {
    const s2 = getS2(year === undefined ? moment().year() : year);
    return (
      translate(TLCode.DutiesBetweenStart) +
      ' ' +
      moment(s2.beginning).format(dateFormat) +
      translate(TLCode.DutiesBetweenEnd) +
      moment(s2.end).format(dateFormat)
    );
  }, [year, translate]);

  return year === undefined ? (
    <></>
  ) : (
    <div style={{ marginTop: '20px' }}>
      <div style={{ backgroundColor: '#dbfcfb', padding: '2px 10px' }}>
        <b>{'S1 : '}</b>
        {S1Dates}
      </div>
      <div style={{ backgroundColor: '#edddc9', padding: '2px 10px', marginTop: '5px' }}>
        <b>{'S2 : '}</b>
        {S2Dates}
      </div>
    </div>
  );
};
